routes.$inject = ['$stateProvider'];

export default function routes($stateProvider) {
  $stateProvider
    .state('login', {
      url: '/login',
      template: require('./login.html'),
      controller: 'LoginController',
      controllerAs: 'login',
      params: {
        failedLogin: null
      }
    });
}


// WEBPACK FOOTER //
// ./src/client/app/login/login.route.js